<template>
  <div class="table_wrap pb10">
    <div class="btn_wrap pb16 text_right">
      <el-button type="save" @click="addCategory">분야 등록</el-button>
    </div>
    <div class="el-table list-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition el-table__body-wrapper is-scrolling-none">
      <div class="">
        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;" class="el-table__header">
          <colgroup>
            <col width="100">
            <col width="">
            <col width="">
            <col width="">
            <col width="200">
            <col width="200">
          </colgroup>
          <thead class="has-gutter">
          <tr>
            <th class="is-leaf list-header">
              <div class="cell">분야순서</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">분야명(한국어)</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">분야명(영어)</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">분야명(중국어)</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">노출</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">옵션</div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="categoryData.length === 0">
            <td colspan="5">
              <div class="cell text-center">
                데이터가 없습니다.
              </div>
            </td>
          </tr>
          <tr v-for="(category, index) in categoryData" :key="`category${index}`" class="el-table__row">
            <td>
              <div class="cell text-center">
                {{ category.oc_seq }}
              </div>
            </td>
            <td>
              <div class="cell text-center">
                <div style="width: 250px; display: inline-block;">
                  {{category.oc_kor }}
                </div>
              </div>
            </td>
            <td>
              <div class="cell text-center">
                {{ category.oc_eng }}
              </div>
            </td>
            <td>
              <div class="cell text-center">
                {{ category.oc_cn }}
              </div>
            </td>
            <td>
              <div class="cell text-center">
                <div style="width: 150px; display: inline-block;">
                  {{ category.oc_display === 1? '노출' : '미노출' }}
                </div>
              </div>
            </td>
            <td>
              <div class="cell text-center">
                <div class="row-info">
                  <el-button @click="openUpdateModal(index)">
                    수정
                  </el-button>
                  <el-button :disabled="category.oc_lock===1" @click="deleteCategory(category.oc_idx)">
                    삭제
                  </el-button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <category-create-modal :categoryType="categoryType"></category-create-modal>
    <category-update-modal :categoryType="categoryType"></category-update-modal>
  </div>
</template>

<script>

import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";
import elFileMixins from "@/mixins/elFileMixins";
import DeleteClass from "@/mixins/deleteClass";
import CategoryUpdateModal from "@/components/modal/CategoryUpdateModal";
import EventBus from "@/utils/event-bus";
import CategoryCreateModal from "@/components/modal/CategoryCreateModal";

export default {
  name: "CategoryComponent",
  mixins: [elFileMixins, imageOption],
  components: {CategoryCreateModal, CategoryUpdateModal},
  inject: ['changeLoading'],
  provide() {
    return {}
  },
  props: {
    categoryType: ''
  },
  data() {
    return {
      beforeBannerData: [],
      categoryData: [],
      keyName: 'oc_idx',
      DeleteClass: null,

      selectIndex: null,
      changeData: false,
      allChangeData: false,
    }
  },
  created() {
    this.newDeleteClass();
    this.getList()
  },
  mounted() {
    EventBus.$on('getList', this.getList);
  },
  beforeDestroy() {
    EventBus.$off('getList')
  },
  destroyed() {
  },
  computed: {},
  methods: {
    newDeleteClass() {
      let deleteOptions = {
        func: this.$api.$online.deleteCategory,
        apiParamSet: {},
        keyName: this.keyName,
        successType: 1,
        errorTypes: {
          '-403' : '권한이 없습니다.',
          '-100' : '필수값이 없습니다.',
          '-103' : '존재하지 않는 분야입니다.'
        },
        afterFunc: this.deleteAfterFunc,
      }
      this.DeleteClass = new DeleteClass(deleteOptions);
    },
    getList() {
      let params = {
        ip: 0,
        ty: this.categoryType
      }
      this.$api.$online.getCategory(params).then(res => res.Data.Result).then(res => {
        if(!util.isEmpty(res.List)) {
          this.beforeBannerData = JSON.parse(JSON.stringify(res.List));
          this.categoryData = res.List;
        }
      })
    },
    openUpdateModal(index){
      this.$modal.show('category-update-modal',{'index':index,'data':this.categoryData});
    },
    addCategory() {
      this.$modal.show('category-create-modal');
    },
    deleteCategory(idx){
      this.createConfirm({
        content: '분야내 모든 리스트가 삭제됩니다. <br> 정말 삭제하시겠습니까?',
        confirm: () => {
          this.changeLoading(true);
          this.DeleteClass.runDelete(idx);
        }
      })
    },
    deleteAfterFunc(key){
      this.changeLoading(false);
      this.createAlert({
        content: '삭제되었습니다.',
        hide: () => {
          this.getList()
        }
      })
    }
  },
  watch: {
  },
}
</script>

<style scoped>

</style>
